export default __webpack_public_path__ + "static/media/contactMail.298a597e.webp";